// useSelectedManager Выбор менеджера аутстафф
import { useEffect, useState, useMemo } from 'react';
import { useStaffStore, useDepartmentsStore, useContractsStore, useContractOrdersStore } from 'storeZustand';
import { useShallow } from 'zustand/react/shallow';

const useSelectedManager = (manager = null) => {
	const [selectedManager, setSelectedManager] = useState(null);

	// Выбранный департамент
	const [selectedDepartment] = useDepartmentsStore(useShallow((state) => [
		state.selectedDepartment
	]));

	// Сотрудники аутстафф
	const [
		managersList,
		getOutstaffManagers
	] = useStaffStore(useShallow((state) => [
		state.managersList,
		state.getOutstaffManagers
	]))

	// Договоры клиента
	const [
		addFilter,
		filters
	] = useContractsStore(useShallow((state) => [
		state.addFilter,
		state.filters
	]));

	// Заказы
	const [
		addOrderFilter,
		orderFilters
	] = useContractOrdersStore(useShallow((state) => [
		state.addOrderFilter,
		state.orderFilters
	]));

	// Сброс менеджера
	useEffect(() => {
		if (Object.keys(filters).length === 0) {
			setSelectedManager(null);
		}
	}, [filters]);

	// Загрузка менеджеров департамента
	useEffect(() => {
		if (selectedDepartment) {
			getOutstaffManagers(selectedDepartment);
		}
	}, [selectedDepartment]);

	// Выбранный менеджер при редактировании
	useEffect(() => {
		if (manager) {
			setSelectedManager(manager);
		}
	}, [manager]);

	// Список сотрудников для селекта
	const outstaffManagerList = useMemo(() => {
		return managersList?.map((manager) => ({
			value: manager.id,
			label: `${manager.surname} ${manager.name}`,
		})) ?? [];
	}, [managersList]);

	const handleManagerChange = (value) => {
		setSelectedManager(value);
	};

	const handleManagerFetch = async (value) => {
		setSelectedManager(value);

		const filters = {
			manager_id: value
		};

		addFilter(filters); // контракты
		addOrderFilter(filters); // заказы
	};

	return {
		selectedManager,
		outstaffManagerList,
		handleManagerChange,
		handleManagerFetch,
	};
};

export default useSelectedManager;